export default __webpack_public_path__ + "ff07e5d30495f3caea782287200dbb5d.svg";